import { VCol } from 'vuetify/lib/components/VGrid';
import { VExpansionPanel } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanelContent } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanelHeader } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanels } from 'vuetify/lib/components/VExpansionPanel';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c(VExpansionPanels, {
    staticClass: "mb-4",
    model: {
      value: _vm.panel,
      callback: function ($$v) {
        _vm.panel = $$v;
      },
      expression: "panel"
    }
  }, [_c(VExpansionPanel, [_c(VExpansionPanelHeader, [_c('div', [_vm._v("IS FM Fields")])]), _c(VExpansionPanelContent, [_c(VRow, {
    staticClass: "pa-4",
    staticStyle: {
      "min-width": "0"
    }
  }, [_c(VCol, {
    attrs: {
      "cols": "12",
      "md": "4"
    }
  }, [_c(VTextField, {
    attrs: {
      "disabled": _vm.disabled,
      "label": _vm.$i18n_t('Common.doorId'),
      "color": _vm.color,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "hide-details": ""
    },
    model: {
      value: _vm.propObject.doorId,
      callback: function ($$v) {
        _vm.$set(_vm.propObject, "doorId", $$v);
      },
      expression: "propObject.doorId"
    }
  })], 1), _c(VCol, {
    attrs: {
      "cols": "12",
      "md": "4"
    }
  }, [_c(VTextField, {
    attrs: {
      "disabled": _vm.disabled,
      "label": _vm.$i18n_t('Common.floor'),
      "color": _vm.color,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "hide-details": ""
    },
    model: {
      value: _vm.propObject.floor,
      callback: function ($$v) {
        _vm.$set(_vm.propObject, "floor", $$v);
      },
      expression: "propObject.floor"
    }
  })], 1), _c(VCol, {
    attrs: {
      "cols": "12",
      "md": "4"
    }
  }, [_c(VTextField, {
    attrs: {
      "disabled": _vm.disabled,
      "label": _vm.$i18n_t('Common.room'),
      "color": _vm.color,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "hide-details": ""
    },
    model: {
      value: _vm.propObject.room,
      callback: function ($$v) {
        _vm.$set(_vm.propObject, "room", $$v);
      },
      expression: "propObject.room"
    }
  })], 1)], 1)], 1)], 1)], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };